module.exports = __webpack_public_path__ + "static/icon1-d160478f988f53963363c41a647c3c3f.svg";